exports = module.exports = require("../../../css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, "._1KdiDDABh-ps4P9o_00Hl2{height:100%;width:100%}", ""]);
// Exports
exports.locals = {
	"composeFormDroppable": "_1KdiDDABh-ps4P9o_00Hl2"
};